import Client from "features/Client/ClientList/Client";

const ClientPage: React.FC = () => {
  return <Client />;
};

export default ClientPage;
